// JS for handling Navigation events
var mouseOutTimer;             // timer used to delay hiding of menu after mouse leaves
var mouseOutHideDelay = 100;  // time (in ms) before menu is closed after mouse leaves
var menuVisible = false;
var utilityMenuVisible = false;

var mobileMenuIsOpen = false;
var searchModalIsOpen = false;

const twFlexClass = "tw-flex";
const twBlockClass = "tw-block";
const twHiddenClass = "tw-hidden";
const twcBodyMenuMobileOpenClass = "twc-mobile-menu-is-open";
const focusableElementTargets = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';


// Desktop main nav logic
function handleMainMenuListeners(triggerContainers) {
    triggerContainers.forEach((el) => {
        // Show sub menu
        el.addEventListener('mouseenter', function (e) {
            e.preventDefault();
            let hasSubMenu = e.target.querySelector('ul');
            if (hasSubMenu) {
                showMenu(this);
                clearTimeout(mouseOutTimer);
            }
        });
        // Hide the sub menu when mouse hover leaves both the trigger and menu fly-out, but only after a short delay to help people jerky mouse movements (like those using head/eye trackers)
        el.addEventListener('mouseleave', function (e) {
            mouseOutTimer = setTimeout(() => {
                let hasSubMenu = e.target.querySelector('ul');
                if (hasSubMenu) {
                    hideMenu(this);
                }
            }, mouseOutHideDelay);
        });

        // Hide the menu when the user tabs out of it
        el.addEventListener('keydown', (e) => {
            triggerKeydownHandler(e, el);
        });

        // Toggle the menu when the trigger is activated
        let toggleButton = el.querySelector('.js-nav-main-menu-trigger-button');
        if (toggleButton) {
            toggleButton.addEventListener('click', function (e) {
                if(!menuVisible){
                    showMenu(el);
                }
                else{
                    hideMenu(el);
                }
            });
        }
    });
}


// Desktop utility nav logic
function handleUtilityMenuListener(triggerContainer) {
    let triggerButton = triggerContainer.querySelector('button');
    let subMenu = triggerContainer.querySelector('ul');
    triggerButton.addEventListener('click', function (e) {
        if (utilityMenuVisible) {
            hideMenu(triggerContainer, triggerButton);
            utilityMenuVisible = false;
        }
        else {
            subMenu.classList.remove(twHiddenClass);
            subMenu.classList.add(twFlexClass);
            this.setAttribute('aria-expanded', true);
            utilityMenuVisible = true;
        }
    });
    // Hide the menu when the user tabs out of it
    triggerContainer.addEventListener('keydown', (e) => {
        let lastMenuItem = triggerContainer.querySelector('ul > li:last-of-type > a');
        if ((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
            hideMenu(triggerContainer, triggerButton);
            utilityMenuVisible = false;

            if (e.key == 'Escape') {
                triggerButton.focus();
            }
        }
    });
}


// Sub Menu dropdowns visibility logic
function showMenu(el) {
    hideMenuAll();
    let toggleButton = el.querySelector('.js-nav-main-menu-trigger-button');
    toggleButton.setAttribute('aria-expanded', true);
    let subMenu = el.querySelector('ul');
    subMenu.classList.remove(twHiddenClass);
    subMenu.classList.add(twFlexClass);
    menuVisible = true;
}

function hideMenu(el, triggerButton = null) {
    let toggleButton = triggerButton ?  triggerButton : el.querySelector('.js-nav-main-menu-trigger-button');
    if (toggleButton) {
        toggleButton.setAttribute('aria-expanded', false);
    }

    let subMenu = el.querySelector('ul');
    if (subMenu) {
        subMenu.classList.remove(twFlexClass);
        subMenu.classList.add(twHiddenClass);
    }

    menuVisible = false;
}

function hideMenuAll() {

    //Closing Main Desktop Dropdown Menu
    let triggerContainers = document.querySelectorAll('.js-nav-main-menu-container');
    triggerContainers.forEach(function (el) {
        let toggleButton = el.querySelector('.js-nav-main-menu-trigger-button');
        if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', false);
        }

        let subMenu = el.querySelector('ul');
        if (subMenu) {
            subMenu.classList.remove(twFlexClass);
            subMenu.classList.add(twHiddenClass);
        }
    });
    menuVisible = false;

    //Closing Utility Dropdown Menu
    if (utilityMenuVisible) {
        let triggerContainer = document.querySelector('.js-nav-utility-menu-container');
        hideMenu(triggerContainer);
        utilityMenuVisible = false;
    }
}

function triggerKeydownHandler(e, el) {
    // Hide the menu a keyboard user tabs out of it
    let lastMenuItem = el.querySelector('ul li:last-of-type > a');
    if ((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
        hideMenu(el);

        // Move focus back to the menu toggle button if Escape was pressed
        let toggleButton = el.querySelector('.js-nav-main-menu-trigger-button');
        if (e.key == 'Escape') {
            toggleButton.focus();
        }
    }
}


// Desktop Search bar logic
function handleSearchModal(searchWrapper) {
    let openButton = searchWrapper.querySelector('.js-nav-search-open-button');
    let closeButton = searchWrapper.querySelector('.js-nav-search-close-button');
    let searchInput = searchWrapper.querySelector('#searchBar');
    let modal = searchWrapper.querySelector('.js-nav-search-bar');

    let focusable = modal.querySelectorAll(focusableElementTargets);
    let firstFocusableElement = focusable[0];
    let lastFocusableElement = focusable[focusable.length - 1];

    // Show and move focus into the search modal when the search button is activated
    openButton.addEventListener('click', function (e) {
        e.stopPropagation();
        modal.classList.remove(twHiddenClass);
        modal.classList.add(twFlexClass);
        searchInput.focus();
        searchModalIsOpen = true;
    });

    // Hide the search modal and move focus back to the search button when the close button is activated
    closeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSearch(modal, openButton);
    });

    // Trap keyboard focus inside the modal
    modal.addEventListener('keydown', function (e) {
        if (searchModalIsOpen) {
            if (e.key == 'Tab') {
                if (!e.shiftKey) {
                    if (document.activeElement == lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement == firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }

            if (e.key == 'Escape') {
                closeSearch(modal, openButton);
            }
        }
    });
}

function closeSearch(modal, openButton) {
    modal.classList.remove(twFlexClass);
    modal.classList.add(twHiddenClass);
    openButton.focus();
    searchModalIsOpen = false;
}


// Mobile menu logic
function handleMobileMenuListeners(mobileNav, mobileMenuDialogContainer){
    let openButton = mobileNav.querySelector('.js-nav-mobile-menu-open-button');
    let closeButton = mobileMenuDialogContainer.querySelector('.js-nav-mobile-menu-close-button');
    let modal = mobileMenuDialogContainer;
    let menu = modal.querySelector('.js-nav-mobile-menu-items-container');
    let focusable = modal.querySelectorAll(focusableElementTargets);
    let firstFocusableElement = focusable[0];
    let lastFocusableElement = focusable[focusable.length - 1];

    // Show and move focus into the mobile menu when the hamburger icon button is activated
    openButton.addEventListener('click', function (e) {
        e.stopPropagation();
        modal.classList.add(twBlockClass);
        modal.classList.remove(twHiddenClass);
        closeButton.focus();
        document.body.classList.add(twcBodyMenuMobileOpenClass);
        mobileMenuIsOpen = true;
    });

    // Hide the mobile menu and move focus back to the hamburger icon button when the close button is activated
    closeButton.addEventListener('click', function (e) {
        closeMobileMenu(modal, openButton);
    });

    // Trap keyboard focus inside the mobile menu
    modal.addEventListener('keydown', function (e) {
        if (mobileMenuIsOpen) {
            if (e.key == 'Tab') {
                if (!e.shiftKey) {
                    if (document.activeElement == lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement == firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }

            if (e.key == 'Escape') {
                closeMobileMenu(modal, openButton);
            }
        }
    });

    let accordionTriggers = menu.querySelectorAll('.js-nav-mobile-menu-container');
    accordionTriggers.forEach((el) => {
        let triggerButton = el.querySelector(":scope > button");
        let drawerMenu = el.querySelector(":scope > div > ul");
        triggerButton.addEventListener("click", (e) => {
            let menuIsOpen = triggerButton.getAttribute('aria-expanded');
            if(menuIsOpen == 'true'){
                triggerButton.setAttribute('aria-expanded', 'false');
                drawerMenu.classList.remove(twFlexClass);
                drawerMenu.classList.add(twHiddenClass);
            }
            else{
                triggerButton.setAttribute('aria-expanded', 'true');
                drawerMenu.classList.remove(twHiddenClass);
                drawerMenu.classList.add(twFlexClass);
            }
        });

    });
}

function closeMobileMenu(modal, openButton) {
    modal.classList.add(twHiddenClass);
    modal.classList.remove(twBlockClass);
    openButton.focus();
    document.body.classList.remove(twcBodyMenuMobileOpenClass);
    mobileMenuIsOpen = false;
}


// Main function that applies all logic
function main() {
    // Desktop Menu - main items
    let mainMenuContainers = document.querySelectorAll('.js-nav-main-menu-container');
    if(mainMenuContainers){
        handleMainMenuListeners(mainMenuContainers);
    }

    // Desktop Utility Menu
    let utilityMenuContainer = document.querySelector('.js-nav-utility-menu-container');
    if(utilityMenuContainer){
        handleUtilityMenuListener(utilityMenuContainer);
    }

    // Desktop Search
    let searchWrapper = document.querySelector('.js-nav-search-container');
    if(searchWrapper){
        handleSearchModal(searchWrapper);
    }

    // Mobile Menu
    let mobileMenuContainer = document.querySelector('.js-nav-mobile-container');
    let mobileMenuDialogContainer = document.querySelector('.js-nav-mobile-menu-modal');
    if(mobileMenuDialogContainer && mobileMenuContainer){
        handleMobileMenuListeners(mobileMenuContainer, mobileMenuDialogContainer);
    }

    window.addEventListener("resize", function(){
        if(window.innerWidth < 768){
            hideMenuAll();
        }
    });
}

export default function () {
    main();
}
